<template lang="pug">
  .pdp-missing-mens-advisor.text-center(v-if="showMissingMensAdvisor")
    p.upper.xs-f-xsmall.max-at-tweak
      | Not sure of your color?&#32;
      a.underline.semi-bold.xs-f-xsmall.max-at-tweak(href="/color-advisor-men") find&nbsp;my&nbsp;color&nbsp;match

</template>

<script>
  import vueQuizSvc from '@services/vueQuizSvc';

  export default {
    name: "PdpMissingMensAdvisor",

    data() {
      return {
        showMissingMensAdvisor: true
      };
    },

    created() {
      vueQuizSvc.isQuizComplete({ name: 'mister_advisor' }).then(res => {
        this.showMissingMensAdvisor == !res.data.isComplete;
      });
    }
  };
</script>

<style scoped lang="stylus">
  .pdp-missing-mens-advisor
    padding 1em

</style>
